(function() { module.exports = window["Bernie_l10nBundle_hu_HU"]; }());